import { TinyEmitter } from 'tiny-emitter';

import type { EventPayloadByName } from '@shared/services/socket/types';

type StreamPayload = EventPayloadByName['AGENT_TEST_STREAM_MESSAGE'];
type MessagePayload = EventPayloadByName['AGENT_TEST_MESSAGE'];
type FieldsChangedPayload = EventPayloadByName['AGENT_TEST_FIELDS_CHANGED'];
type SwitchAgentPayloadRaw = EventPayloadByName['AGENT_TEST_SWITCH_AGENT'];

export type AgentTestSwitchPayload = {
  source: 'AGENT_TEST_SWITCH_AGENT' | 'CHANGE_CURRENT_AGENT';
  agentId?: number;
  newAgentId: number;
  newAgentName?: string;
  messageId?: number;
};

type StreamHandler = (payload: StreamPayload) => void;
type MessageHandler = (payload: MessagePayload) => void;
type FieldsChangedHandler = (payload: FieldsChangedPayload) => void;
type SwitchAgentHandler = (payload: AgentTestSwitchPayload) => void;

const emitter = new TinyEmitter();

export const agentTestEvents = {
  onStream: (handler: StreamHandler) => {
    emitter.on('AGENT_TEST_STREAM_MESSAGE', handler);
    return () => emitter.off('AGENT_TEST_STREAM_MESSAGE', handler);
  },
  onMessage: (handler: MessageHandler) => {
    emitter.on('AGENT_TEST_MESSAGE', handler);
    return () => emitter.off('AGENT_TEST_MESSAGE', handler);
  },
  onFieldsChanged: (handler: FieldsChangedHandler) => {
    emitter.on('AGENT_TEST_FIELDS_CHANGED', handler);
    return () => emitter.off('AGENT_TEST_FIELDS_CHANGED', handler);
  },
  onSwitchAgent: (handler: SwitchAgentHandler) => {
    emitter.on('AGENT_TEST_SWITCH_AGENT', handler);
    return () => emitter.off('AGENT_TEST_SWITCH_AGENT', handler);
  },
  emitStream: (payload: StreamPayload) => {
    emitter.emit('AGENT_TEST_STREAM_MESSAGE', payload);
  },
  emitMessage: (payload: MessagePayload) => {
    emitter.emit('AGENT_TEST_MESSAGE', payload);
  },
  emitFieldsChanged: (payload: FieldsChangedPayload) => {
    emitter.emit('AGENT_TEST_FIELDS_CHANGED', payload);
  },
  emitSwitchAgent: (payload: AgentTestSwitchPayload | SwitchAgentPayloadRaw) => {
    if ('source' in payload) {
      emitter.emit('AGENT_TEST_SWITCH_AGENT', payload);
      return;
    }

    const parsedAgentId = Number(payload.agent_id);
    const parsedNewAgentId = Number(payload.new_agent_id);

    if (!Number.isFinite(parsedNewAgentId)) return;

    const normalizedPayload: AgentTestSwitchPayload = {
      source: 'AGENT_TEST_SWITCH_AGENT',
      agentId: Number.isFinite(parsedAgentId) ? parsedAgentId : undefined,
      newAgentId: parsedNewAgentId,
      newAgentName: payload.new_agent_name,
      messageId: payload.message_id,
    };

    emitter.emit('AGENT_TEST_SWITCH_AGENT', normalizedPayload);
  },
};
